import type { ReactNode } from 'react';
import { RecordPicker } from '../../components/RecordPicker.js';

interface SaasTenantOption {
  readonly saasTenantId: string;
  readonly tenantCode: string;
  readonly tenantName: string;
}

interface Props {
  readonly label: string;
  readonly value: string;
  readonly onPick: (id: string) => void;
  readonly testId?: string;
}

/** SaaS tenant chooser shared by the M43 consoles. */
export function SaasTenantPicker({
  label,
  value,
  onPick,
  testId = 'field-tenant-id',
}: Props): ReactNode {
  return (
    <RecordPicker<SaasTenantOption>
      endpoint="/v1/saas/tenants?pageSize=500"
      idField="saasTenantId"
      label={label}
      testId={testId}
      value={value}
      optionLabel={(t) => `${t.tenantCode} — ${t.tenantName}`}
      onPick={onPick}
      emptyText="No tenants yet"
    />
  );
}
